import React, { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import swal from 'sweetalert';
import { clients_services } from '../../services/clients_services';
import { useNavigate, useParams } from 'react-router-dom';



const InscriptionClient = () => {
    // declarations 
    const navigate = useNavigate()
    const [wait, setWait] = useState(true)
    const [client, setClient] = useState('');
    const { companyId } = useParams();

    // add client function
    const onChangeAdd = (e) => {
        setClient({
            ...client,
            [e.target.name]: e.target.value
        })
    }

    const handleClient = (e) => {
        e.preventDefault();

        if (
            !client.nom ||
            !client.numeroTel ||
            !client.localisation ||
            !client.prenom ||
            !client.sexe
        ) {
            toast.error("Veillez remplir tous les champs obligatoires!");
            return;
        }

        if (client.numeroTel && client.numeroTel.length !== 9) {
            toast.error("Le numéro de téléphone doit contenir 9 chiffres.");
            return;
        }

        if (client.nom && client.nom.length > 50) {
            toast.error("Le champ nom ne doit pas etre au dela de 50 caracteres.");
            return;
        }

        if (client.prenom && client.prenom.length > 50) {
            toast.error("Le champ prenom ne doit pas etre au dela de 50 caracteres.");
            return;
        }

        setWait(false);

        clients_services.addClientByScanQr(companyId ,client)
            .then((res) => {
                // console.log("clientRes :", res);
                if (res.status === 201) {
                    navigate("/auth/loginClient/");
                    toast.success("Compte creé avec succès.");

                    setClient({
                        nom: "",
                        prenom: "",
                        localisation: "",
                        numeroTel: "",
                        sexe: "",
                    });
                    setWait(true);

                }

            })
            .catch((err) => {
                setWait(true);
                console.log("err : ", err);
                if (err.response) {
                    if (err.response.status === 400) {
                        navigate("/auth/loginClient");
                        // swal({
                        //     text: "Votre séssion a expiré, veillez vous connecter",
                        //     icon: "error",
                        //     button: "Fermer",
                        // });
                    }
                    if (err.response.status === 404) {
                        toast.error("Structure introuvable")
                    }

                    if (err.response.status === 500) {
                        toast.error("Erreur d'exécution dans l'application , veillez vous reconnecter.")
                    }
                }
            });
    }

    return (
        <div className="container ">
            <form className="form bg-white px-4 py-4  formulaire" onSubmit={handleClient}>
                <div className="row ">
                    <h3 className='titre'>Inscription</h3>
                    <p className='mt-1 texte'>Veillez remplir les champs suivants pour vous enregistrer.
                        Tout les champs sont obligatoires.
                    </p>
                    <div className="col-md-12">
                        <label htmlFor="nom" className="form-label" >
                            Nom du client
                            <span className="text-danger taille_etoile">*</span>
                        </label>
                        <input
                            type="text"
                            name="nom"
                            className="form-control no-focus-outline mb-2"
                            id="nom" value={client.nom} onChange={onChangeAdd}
                        />
                    </div>
                    <div className="col-md-12">
                        <label htmlFor="prenom" className="form-label">
                            Prénom
                            <span className="text-danger taille_etoile">*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control no-focus-outline mb-2"
                            id="prenom" name="prenom" value={client.prenom} onChange={onChangeAdd}
                        />
                    </div>
                    <div className="col-md-12">
                        <label htmlFor="localisation" className="form-label">
                            Localisation
                            <span className="text-danger taille_etoile">*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control no-focus-outline mb-2" id="localisation"
                            name="localisation" value={client.localisation} onChange={onChangeAdd}
                        />
                    </div>
                    <div className="col-md-12">
                        <label htmlFor="numeroTel" className="form-label">
                            Téléphone
                            <span className="text-danger taille_etoile">*</span>
                        </label>
                        <input
                            type="number"
                            className="form-control no-focus-outline mb-2"
                            id="numeroTel" name="numeroTel" value={client.numeroTel} onChange={onChangeAdd}
                        />
                    </div>
                    <div className="col-md-12">
                        <label htmlFor="sexe">
                            Sexe
                            <span className="text-danger taille_etoile">*</span>
                        </label>
                        <select className="form-control mb-2" id='sexe' name='sexe' autoComplete='off' onChange={onChangeAdd} >
                            <option value="" className='text-success' disabled selected>Séléctionner votre sexe</option>
                            <option value="masculin">Masculin</option>
                            <option value="feminin">Feminin</option>
                        </select>
                    </div>
                </div>
                <div className="mt-2 d-flex justify-content-between boutons" >
                    <button type="reset" className="btn btn-secondary btn-sm mr-2 " title='Annuler'><i className='fas fa-times f-3 mr-1'></i>Annuler</button>
                    <div className="d-flex">
                        {
                            wait ?
                                <button type="submit" className="btn btn-success btn-sm" title='Enregistrer le client'> <i className='fas fa-plus mr-1 f-3'></i>Enregistrer</button>
                                :
                                <button className="btn btn-success btn-sm"> <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Enregistrement..</button>
                        }
                    </div>
                </div>
            </form>
        </div>
    );
};

export default InscriptionClient;